<canvas #myCanvas id="myCanvas" 
    (mousedown)="onMouseDown($event)" 
    (mouseup)="onMouseUp($event)"
    (mousemove)="onMouseMove($event)">
</canvas>